module.exports = __webpack_public_path__ + "node_modules/devextreme/dist/css/icons/dxicons.woff";